import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const url = `${API_ENDPOINT}/api/v1/system_configuration`;

const sysConfigService = {
  list,
  show,
  update
};

function list() {
  return submit('GET', url, {}, {});
}

function show(id) {
  return submit('GET', `${url}/${id}`, {}, {});
}

function update(data) {
  return submit('PATCH', `${url}/`, data, {});
}

export default sysConfigService;
